import { Component, Vue, Prop } from 'vue-property-decorator';
import MaterialCard from '@/components/Card.component/Card.component';

@Component({
  components: {
    MaterialCard
  },
  inheritAttrs: false
})
export default class ChartCardComponent extends Vue {
  @Prop({ type: Object, default: () => ({}) }) data!: Object;
  @Prop({ type: Array, default: () => ([]) }) eventHandlers!: string[];
  @Prop({ type: Object, default: () => ({}) }) options!: Object;
  @Prop({ type: String, default: undefined }) ratio!: string;
  @Prop({ type: Array, default: () => ([]) }) responsiveOptions!: string[];
  @Prop({ type: Object, default: () => ({ "height" : "200px"}) }) styles!: Object;
  @Prop({ type: String, required: true, validator: v => ['Bar', 'Line', 'Pie'].includes(v) }) type!: string;
}